<template>
    <div class="form-group my-2">
        <div class="input-group search w-100">
            <input type="text" class="form-control" @input="$emit('input', $event.target.value)"
                   :value="value"
                   :disabled="disabled"
                   :placeholder="placeholder">
            <div class="input-group-append">
                <span class="input-group-text"><i class="fa fa-search"></i></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: { default: null },
            placeholder: { default: 'Search...' },
            disabled: { default: false },
        }
    }
</script>
